// Λίστα με τις προκυρίξεις των διορισμών
export const PROKIRIKSI_OPTIONS = [
    // { value: "1ge_2019", label: "1ΓΕ_2019" },
    { value: "1ge_2023", label: "1ΓΕ/2023 - Πρωτοβάθμιας Γενικής Εκπαίδευσης & ΠΕ79.01/ ΠΕ79.02" },
    { value: "1ea_2025", label: "1ΕΑ/2025 - Ειδικού Βοηθητικού Προσωπικού (Ε.Β.Π.) κλάδου ΔΕ01" },
    // { value: "2ea_2019", label: "2ΕΑ_2019" },
    // { value: "2ea_2022", label: "2ΕΑ/2022 - Ε.Ε.Π. (Πρωτοβάθμια & Δευτεροβάθμια)" },
    { value: "2ea_2025", label: "2ΕΑ/2025 - Ε.Ε.Π. (Πρωτοβάθμια & Δευτεροβάθμια)" },
    // { value: "2ge_2019", label: "2ΓΕ_2019" },
    { value: "2ge_2023", label: "2ΓΕ/2023 - Δευτεροβάθμιας Γενικής Εκπαίδευσης" },
    // { value: "3ea_2019", label: "3ΕΑ_2019" },
    // { value: "3ea_2022", label: "3ΕΑ/2022 - Ειδικής Αγωγής & Εκπαίδευσης (Πρωτοβάθμια & Δευτεροβάθμια)" },
    { value: "3ea_2025", label: "3ΕΑ/2025 - Ειδικής Αγωγής & Εκπαίδευσης (Πρωτοβάθμια & Δευτεροβάθμια)" }
]

export const TABLE_OPTIONS = [
    { value: "initial", label: "Αρχικός Πίνακας" },
    { value: "cleaned", label: "Εκκαθαρισμένος Πίνακας (πριν τις 19 Αυγ 2025)" },
    { value: "cleaned_aug25", label: "Εκκαθαρισμένος Πίνακας (μετά τις 19 Αυγ 2025)" },
    { value: "cleaned_sept25", label: "Εκκαθαρισμένος Πίνακας (μετά την A' φάση προσλήψεων)" },
    { value: "cleaned_sept25_1", label: "Εκκαθαρισμένος Πίνακας (μετά την B' φάση προσλήψεων)" },
    { value: "cleaned_oct25", label: "Εκκαθαρισμένος Πίνακας (μετά την B' φάση προσλήψεων - συμπληρωματικές)" },
    { value: "cleaned_nov25", label: "Εκκαθαρισμένος Πίνακας (μετά την Γ' φάση προσλήψεων)" },
    { value: "cleaned_jan26", label: "Εκκαθαρισμένος Πίνακας (μετά την Δ' φάση προσλήψεων)" }
    // { value: "cleaned_current", label: "ΕΚΚΑΘΑΡΙΣΜΕΝΟΣ ΠΡΟΣΛΗΨΕΩΝ" } 
]

export const EIDIKI_TABLE_OPTIONS = [
    { value: "Α", label: "Γενικής Εκπαίδευσης" },
    { value: "Β", label: "Κύριος Ειδικής Αγωγής" },
    { value: "Επικουρικός", label: "Επικουρικός Ειδικής Αγωγής" } 
]

export const EIDIKI_TABLE_OPTIONS_D = {
    "Α": "Γενικής",
    "Β": "Κύριος ΕΑΕ",
    "Επικουρικός": "Επικουρικός ΕΑΕ",
};

export const EDUC_OPTIONS = [
    { value: "pe", label: "Πρωτοβάθμια Εκπαίδευση" },
    { value: "de", label: "Δευτεροβάθμια Εκπαίδευση" } 
]

export const EDU_SPECIALTIES = [
  "ΠΕ01",
  "ΠΕ02",
  "ΠΕ03",
  "ΠΕ04.01",
  "ΠΕ04.02",
  "ΠΕ04.04",
  "ΠΕ04.05",
  "ΠΕ05",
  "ΠΕ06",
  "ΠΕ07",
  "ΠΕ08",
  "ΠΕ11",
  "ΠΕ21",
  "ΠΕ22",
  "ΠΕ23",
  "ΠΕ25",
  "ΠΕ28",
  "ΠΕ29",
  "ΠΕ30",
  "ΠΕ33",
  "ΠΕ34",
  "ΠΕ60",
  "ΠΕ61",
  "ΠΕ70",
  "ΠΕ71",
  "ΠΕ78",
  "ΠΕ79.01",
  "ΠΕ79.01/ΤΕ16",
  "ΠΕ80",
  "ΠΕ81",
  "ΠΕ82",
  "ΠΕ83",
  "ΠΕ84",
  "ΠΕ85",
  "ΠΕ86",
  "ΠΕ87.01",
  "ΠΕ87.02",
  "ΠΕ87.03",
  "ΠΕ87.04",
  "ΠΕ87.05",
  "ΠΕ87.06",
  "ΠΕ87.07",
  "ΠΕ87.08",
  "ΠΕ87.09",
  "ΠΕ87.10",
  "ΠΕ88.01",
  "ΠΕ88.02",
  "ΠΕ88.03",
  "ΠΕ88.04",
  "ΠΕ88.05",
  "ΠΕ89.01",
  "ΠΕ89.02",
  "ΠΕ90",
  "ΠΕ91.01",
  "ΠΕ91.02",
  "ΤΕ01.06",
  "ΤΕ01.07",
  "ΤΕ01.13",
  "ΤΕ01.19",
  "ΤΕ01.25",
  "ΤΕ01.30",
  "ΤΕ02.02",
  "ΤΕ02.04",
  "ΤΕ02.06",
  "ΤΕ02.07",
  "ΤΕ16.00",
  "ΔΕ01",
  "ΔΕ01.17",
  "ΔΕ02.01",
  "ΔΕ02.02"
];

export const EDU_SPECIALTIES_APPOINTMENTS = [
    "ΔΕ01",
    "ΔΕ02.01",
    "ΔΕ02.02",
    "ΠΕ01",
    "ΠΕ01.ΕΑΕ",
    "ΠΕ02",
    "ΠΕ02.ΕΑΕ",
    "ΠΕ03",
    "ΠΕ03.ΕΑΕ",
    "ΠΕ04.01",
    "ΠΕ04.01.ΕΑΕ",
    "ΠΕ04.02",
    "ΠΕ04.02.ΕΑΕ",
    "ΠΕ04.04",
    "ΠΕ04.04.ΕΑΕ",
    "ΠΕ04.05",
    "ΠΕ04.05.ΕΑΕ",
    "ΠΕ05",
    "ΠΕ06",
    "ΠΕ06.ΕΑΕ",
    "ΠΕ07",
    "ΠΕ08",
    "ΠΕ08.ΕΑΕ",
    "ΠΕ11",
    "ΠΕ11.ΕΑΕ",
    "ΠΕ21",
    "ΠΕ22",
    "ΠΕ23",
    "ΠΕ25",
    "ΠΕ28",
    "ΠΕ29",
    "ΠΕ30",
    "ΠΕ33",
    "ΠΕ34",
    "ΠΕ60",
    "ΠΕ60.ΕΑΕ",
    "ΠΕ61",
    "ΠΕ70",
    "ΠΕ70.ΕΑΕ",
    "ΠΕ71",
    "ΠΕ78",
    "ΠΕ78.ΕΑΕ",
    "ΠΕ79.01",
    "ΠΕ79.01.ΕΑΕ",
    "ΠΕ80",
    "ΠΕ80.ΕΑΕ",
    "ΠΕ81",
    "ΠΕ81.ΕΑΕ",
    "ΠΕ82",
    "ΠΕ82.ΕΑΕ",
    "ΠΕ83",
    "ΠΕ83.ΕΑΕ",
    "ΠΕ84",
    "ΠΕ84.ΕΑΕ",
    "ΠΕ85",
    "ΠΕ85.ΕΑΕ",
    "ΠΕ86",
    "ΠΕ86.ΕΑΕ",
    "ΠΕ87.01",
    "ΠΕ87.02",
    "ΠΕ87.02.ΕΑΕ",
    "ΠΕ87.03",
    "ΠΕ87.03.ΕΑΕ",
    "ΠΕ87.04",
    "ΠΕ87.05",
    "ΠΕ87.06",
    "ΠΕ87.06.ΕΑΕ",
    "ΠΕ87.07",
    "ΠΕ87.08",
    "ΠΕ87.08.ΕΑΕ",
    "ΠΕ87.09",
    "ΠΕ87.09.ΕΑΕ",
    "ΠΕ87.10",
    "ΠΕ88.01",
    "ΠΕ88.01.ΕΑΕ",
    "ΠΕ88.02",
    "ΠΕ88.02.ΕΑΕ",
    "ΠΕ88.03",
    "ΠΕ88.03.ΕΑΕ",
    "ΠΕ88.04",
    "ΠΕ88.04.ΕΑΕ",
    "ΠΕ88.05",
    "ΠΕ88.05.ΕΑΕ",
    "ΠΕ89.01",
    "ΠΕ89.01.ΕΑΕ",
    "ΠΕ89.02",
    "ΠΕ89.02.ΕΑΕ",
    "ΠΕ90",
    "ΠΕ91.01",
    "ΠΕ91.01.ΕΑΕ",
    "ΠΕ91.02",
    "ΤΕ01.04",
    "ΤΕ01.06",
    "ΤΕ01.13.ΕΑΕ",
    "ΤΕ01.19",
    "ΤΕ01.19.ΕΑΕ",
    "ΤΕ01.25",
    "ΤΕ02.01",
    "ΤΕ02.02",
    "ΤΕ02.05.ΕΑΕ",
    "ΤΕ16.00",
    "ΤΕ16.00.ΕΑΕ"
]